import React, { useState } from 'react';
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import VideoThumbnailService from '../../services/VideoThumbnailService';

export default function ThumbnailUrlDialog({ open, onClose, onImage }) {
  const [url, setUrl] = useState('');
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState('');

  function close() {
    if (downloading) return;
    setUrl('');
    setError('');
    onClose();
  }

  async function submit(event) {
    event.preventDefault();
    // The dialog may sit inside another form, such as the create video dialog.
    event.stopPropagation();
    if (downloading || !url.trim()) return;
    setDownloading(true);
    setError('');
    try {
      const file = await VideoThumbnailService.download(url.trim());
      setUrl('');
      onClose();
      onImage(file);
    } catch (err) {
      setError(
        err.response?.data?.error ||
          'Could not download the image at this URL. Try again.',
      );
    } finally {
      setDownloading(false);
    }
  }

  return (
    <Dialog
      open={open}
      onClose={close}
      onClick={(event) => event.stopPropagation()}
      maxWidth="sm"
      fullWidth
    >
      <form onSubmit={submit}>
        <DialogTitle>Use an image URL</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            margin="dense"
            label="Image URL"
            placeholder="https://…"
            value={url}
            onChange={(event) => setUrl(event.target.value)}
            disabled={downloading}
            helperText="A public link to a JPG or PNG up to 100 MB. Images over 2 MB are compressed. Google Drive share links work."
          />
          {error && (
            <Alert severity="error" sx={{ mt: 1 }}>
              {error}
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={close} disabled={downloading}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            disabled={downloading || !url.trim()}
            startIcon={
              downloading ? <CircularProgress size={16} color="inherit" /> : null
            }
          >
            {downloading ? 'Downloading…' : 'Use image'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
